module.exports = __webpack_public_path__ + "assets/images/project/germany-desktop.jpg?v=3568e967";